var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        row: "",
        "fill-height": "",
        "align-center": "",
        "justify-center": "",
        wrap: ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { shrink: "" } },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "", "justify-center": "" } },
            [
              _c("div", { staticClass: "warning-message" }, [
                _vm._v("\n        Page Under Construction\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticStyle: { "text-transform": "none" },
                  attrs: { to: "/hub", text: "", color: "accent" }
                },
                [_vm._v("\n        Return to Hub\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { shrink: "" } },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "" } },
            [
              _c("lottie-player", {
                staticStyle: { width: "400px", height: "400px" },
                attrs: {
                  src:
                    "https://assets9.lottiefiles.com/packages/lf20_AQcLsD.json",
                  background: "transparent",
                  speed: "1",
                  loop: "",
                  autoplay: ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e394e30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e394e30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageUnderConstruction.vue
// module id = null
// module chunks = 